/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1ActivitytemplatepackagesQueryResponse } from '../../types/GetV1Activitytemplatepackages.ts'

export const getV1ActivitytemplatepackagesQueryKey = () =>
    [{ url: '/v1/ActivityTemplatePackages' }] as const

export type GetV1ActivitytemplatepackagesQueryKey = ReturnType<
    typeof getV1ActivitytemplatepackagesQueryKey
>

/**
 * {@link /v1/ActivityTemplatePackages}
 */
export async function getV1Activitytemplatepackages(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1ActivitytemplatepackagesQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/ActivityTemplatePackages`, ...requestConfig })
    return res
}

export function getV1ActivitytemplatepackagesQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1ActivitytemplatepackagesQueryKey()
    return queryOptions<
        ResponseConfig<GetV1ActivitytemplatepackagesQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1ActivitytemplatepackagesQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Activitytemplatepackages(config)
        },
    })
}

/**
 * {@link /v1/ActivityTemplatePackages}
 */
export function useGetV1Activitytemplatepackages<
    TData = ResponseConfig<GetV1ActivitytemplatepackagesQueryResponse>,
    TQueryData = ResponseConfig<GetV1ActivitytemplatepackagesQueryResponse>,
    TQueryKey extends QueryKey = GetV1ActivitytemplatepackagesQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1ActivitytemplatepackagesQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1ActivitytemplatepackagesQueryKey()

    const query = useQuery(
        {
            ...getV1ActivitytemplatepackagesQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
